module.exports = __webpack_public_path__ + "img/loading.d8102594.gif";